const loaded = new Set();

function prefetchRoute(factory) {
    if (loaded.has(factory)) return;
    loaded.add(factory);
    factory();
}

export function preloadHomeRoutes() {
    const routes = [
        () => import('../pages/Treks'),
        () => import('../pages/Login'),
        () => import('../pages/Signup'),
        () => import('../pages/Regions'),
    ];
    const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 2000));
    idle(() => routes.forEach((r) => prefetchRoute(r)));
}
